import { render, staticRenderFns } from "./MainCarousel.vue?vue&type=template&id=13595b32&scoped=true"
import script from "./MainCarousel.vue?vue&type=script&lang=js"
export * from "./MainCarousel.vue?vue&type=script&lang=js"
import style0 from "./MainCarousel.vue?vue&type=style&index=0&id=13595b32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13595b32",
  null
  
)

export default component.exports